<template>
  <div>
    <div class="testCreationBox">
      <div class="titleBox">
        <div class="titleLeft">
          <img
            src="../../assets/images/titleArrow.png"
            alt=""
            @click="returnTopic()"
          />
        </div>
        <div class="titleCentre">组题记录</div>
        <div class="titleRight"></div>
      </div>
      <ul
        class="testCreationUl"
        @scroll="handleScroll"
        v-if="testCreationList.length > 0"
      >
        <li
          v-for="(item, index) in testCreationList"
          :key="index"
          @click="testCreationListClick(item)"
        >
          <div class="liLeft">{{ item.title }}</div>
          <div class="liRight">
            <span>{{ item.answerNum }}</span>
            /
            <span>{{ item.questionNum }}</span>
            <img src="../../assets/images/towRightArrow.png" alt="" />
          </div>
        </li>
      </ul>
      <div v-else class="notBox">
        <img src="../../assets/images/None.png" alt="" />
        <span>暂无数据</span>
      </div>
    </div>
  </div>
</template>

<script>
// import { studyPaperPage } from "@/api/topic/index.js";
import * as topicApi from "@/api/topic/index.js";
import * as topicsApi from "@/api/topics/index.js";

export default {
  data() {
    return {
      studyBankId: "",
      testCreationList: [],
      // testCreationAllList: [],
      allTotal: 0,
      pageNum: 1,
    };
  },
  created() {
    this.studyBankId = this.$route.query.studyBankId;
    this.getStudyPaperPage();
  },
  computed: {
    // 根据 questionType 返回对应的 API 模块
    api() {
      return this.$route.query.questionType == 1 ? topicApi : topicsApi;
    },
  },
  methods: {
    async getStudyPaperPage() {
      const setList = {
        pageNum: this.pageNum,
        pageSize: 15,
        studyBankId: this.studyBankId,
      };
      const { data } = await this.api.studyPaperPage(setList);
      console.log("data", data);
      this.allTotal = data.total;
      this.testCreationList = this.testCreationList.concat(data.rows);
      console.log("this.testCreationList", this.testCreationList);
    },
    returnTopic() {
      this.$router.push({
        path: "/groupQuestion",
        query: { studyBankId: this.studyBankId,
          questionType: this.$route.query.questionType,
         },
      });
    },
    handleScroll(event) {
      const element = event.target;
      if (element.scrollHeight - element.scrollTop === element.clientHeight) {
        // Scrolled to the bottom
        this.pageNum++;
        this.handleScrollToBottom();
      }
    },
    handleScrollToBottom() {
      // Your logic when scrolled to the bottom
      // console.log("Scrolled to the bottom!");
      if (this.testCreationList.length < this.allTotal) {
        this.getStudyPaperPage();
      }
    },
    testCreationListClick(item) {
      this.$router.push({
        path: "/homework",
        query: {
          studyPaperId: item.studyPaperId,
          studyBankId: this.studyBankId,
          typeFlag: 5,
          name: "testCreation",
          questionType: this.$route.query.questionType,
        },
      });
    },
    onClose({ position, instance }, item, index) {
      console.log("Swipe cell closing:", position, item, index);
      switch (position) {
        case "left":
        case "cell":
        case "outside":
          instance.close();
          break;
        case "right":
          // Example: Implement a confirm dialog before actually deleting
          // For now, just closing it. You'd typically remove the item from testCreationList here.
          console.log("Delete action triggered for:", item);
          // this.testCreationList.splice(index, 1); // Example of actual deletion
          instance.close();
          break;
      }
    },
  },
};
</script>

  <style lang="scss" scoped>
.testCreationBox {
  position: fixed;
  top: 0%;
  left: 0%;
  right: 0%;
  bottom: 0%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(196, 249, 247, 0.5) 0%,
    rgba(255, 255, 255, 0.5) 135px
  );
  .titleBox {
    // position: absolute;
    // top: 0%;
    // left: 0%;
    padding: 44px 16px 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 88px;
    // overflow: hidden;
    // z-index: 999;
    .titleLeft {
      width: 20px;
      height: 20px;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .titleCentre {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #121212;
      text-align: left;
      font-style: normal;
    }
    .titleRight {
    }
  }
  .testCreationUl {
    padding: 0 16px;
    // margin-top: 88px;
    width: 100%;
    height: calc(100% - 88px); /* 设置容器的高度为父元素高度减去 88px */
    overflow-y: auto;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      list-style: none;
      height: 54px;
      border-bottom: 1px solid #eeeeee;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 54px;
      text-align: left;
      font-style: normal;
      white-space: nowrap; /* 文本不换行 */
      overflow: hidden; /* 隐藏溢出的文本 */
      text-overflow: ellipsis; /* 显示省略号 */
      .liLeft {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        text-align: left;
        font-style: normal;
      }
      .liRight {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        text-align: left;
        font-style: normal;
        span:first-child {
          display: inline-block;
          color: #1bbf8d;
        }
      }
    }
  }

  .notBox {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100vh - 88px);
    img {
      width: 113px;
      height: 106px;
    }
    span {
      margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #aaaaaa;
      line-height: 17px;
      text-align: center;
      font-style: normal;
    }
  }
}
</style>